import React from 'react';

import RichText from 'components/RichText/RichText';

import Input from '../../../components/Input/Input';
import { CheckoutDesignTabProps } from '../types';

const SettingsTab: React.FC<CheckoutDesignTabProps> = ({ formikProps }) => {
  const { handleChange, handleBlur, values, touched, errors } = formikProps;

  return (
    <div className="w-[456px] mx-auto">
      <RichText
        title="General"
        description="Start with setting up your checkout mandatory fields"
        className="mb-9"
      />
      <div className="grid grid-cols-2 gap-5">
        <Input
          label="Name"
          placeholder="Name"
          type="text"
          name="name"
          value={values.name}
          onChange={handleChange}
          onBlur={handleBlur}
          isRequired
          state={touched.name && errors.name ? 'error' : 'default'}
          description={touched.name && errors.name ? errors.name : ''}
        />

        <Input
          label="External ID"
          placeholder="External ID"
          type="text"
          name="externalTemplateId"
          value={values.externalTemplateId}
          onChange={handleChange}
          onBlur={handleBlur}
          isRequired
          state={
            touched.externalTemplateId && errors.externalTemplateId
              ? 'error'
              : 'default'
          }
          description={
            touched.externalTemplateId && errors.externalTemplateId
              ? errors.externalTemplateId
              : ''
          }
        />
      </div>
    </div>
  );
};

export default SettingsTab;
